<template>
  <div class="museum">
    <div class="container">
      <FlowchartWithContent
        type="museum"
        :json="json"
      />
    </div>
  </div>
</template>

<script>
import json from '@/../static/flow.json'
import { FlowchartWithContent } from '@/components/Flow'

export default {
  name: 'Museum',
  data () {
    return {
      json: [{}]
    }
  },
  created () {
    this.json = json.museum
  },
  components: {
    FlowchartWithContent
  }
}
</script>

<style lang="scss" scoped>
  .museum {
    
  }
</style>



// WEBPACK FOOTER //
// src/domains/Museum.vue